import 'core-js/actual/promise';

import amountInput from '../../shared/js/modules/amountInput';
import announcementBar from '../../shared/js/modules/announcementBar';
import aponeo from '../../shared/js/modules/aponeo';
import backToTopFixed from '../../shared/js/modules/backToTopFixed';
import basket from '../../shared/js/modules/basket';
import { addToBasketFunctions } from '../../shared/js/modules/basket';
import checkout from '../../shared/js/modules/checkout';
import { _DEBUG } from '../../shared/js/modules/constants';
import contactForm from '../../shared/js/modules/contactForm';
import { getCookie } from '../../shared/js/modules/cookies';
import coupons from '../../shared/js/modules/coupons';
import customer_area from '../../shared/js/modules/customer_area';
import { addDetailLinkFunctions } from '../../shared/js/modules/detailLink';
import { fetchProductDetail } from '../../shared/js/modules/fetchProductDetail';
import filterSort from '../../shared/js/modules/filterSort';
import formValidation from '../../shared/js/modules/form-validation';
import freeShippingProgress from '../../shared/js/modules/freeShippingProgress';
import header from '../../shared/js/modules/header';
import headerNav from '../../shared/js/modules/headerNav';
import headroom from '../../shared/js/modules/headroom';
import interactionCheck from '../../shared/js/modules/interactionCheck';
import jssinglesubmit from '../../shared/js/modules/jssinglesubmit';
import leaflet from '../../shared/js/modules/leaflet';
import { addToLeafletFunctions } from '../../shared/js/modules/leaflet';
import loadingScreen from '../../shared/js/modules/loadingScreen';
import megamenu from '../../shared/js/modules/megamenu';
import packstation from '../../shared/js/modules/packstation';
import password from '../../shared/js/modules/password';
import pdpSkyWrapper from '../../shared/js/modules/pdpSkyWrapper';
import photoswipe from '../../shared/js/modules/photoswipe';
import productTeaser from '../../shared/js/modules/productTeaser';
import productdetail from '../../shared/js/modules/productdetail';
import productlist from '../../shared/js/modules/productlist';
import radioToggle from '../../shared/js/modules/radioToggle';
import searchFlyoutState from '../../shared/js/modules/searchFlyoutState';
import selectBox from '../../shared/js/modules/select-box';
import stickyCartFlyout from '../../shared/js/modules/stickyCartFlyout';
import tierPriceUpdater from '../../shared/js/modules/tierPriceUpdater';
import { setSameHeight } from '../../shared/js/modules/utils';
import { keepalive } from '../../shared/js/modules/utils';
import { initWishlist } from '../../shared/js/modules/wishlist';
import '../../shared/js/plugins/zeynepjs/zeynep';
import { initiateSliders } from './sliders';

// used globally
window.showLoadingScreen = aponeo.showLoadingScreen;
window.setSameHeight = setSameHeight;
window.keepalive = keepalive;
window.addJsDetailLink = addDetailLinkFunctions;
window.addToLeafletFunctions = addToLeafletFunctions;
window.addToBasketFunctions = addToBasketFunctions;
window.getCookie = getCookie;
window.fetchProductDetail = fetchProductDetail;

if (_DEBUG) console.log('running with _DEBUG = TRUE');

(function () {
  // change POST to GET in history to prevent
  // send post again or browser ask "do you want send data agian"
  try {
    history.replaceState(null, document.title, window.location.href);
  } catch (e) {
    console.warn('replaceState not supported:', e);
  }
})();

// same as jquery.getscript but without timestamp
// @see https://api.jquery.com/jquery.getscript/
const currentScript = document.currentScript || document.scripts[document.scripts.length - 1];
let buildNumber = '';
if (currentScript.src.indexOf('?') > 0) {
  buildNumber = currentScript.src.split('?')[1];
}
$.cachedScript = (url, options) => {
  if (/^\/js\/(aponeo_de)\//.test(url)) {
    url = url.replace('/aponeo_de/', '/sparmed_de/');
  }
  options = $.extend(options || {}, {
    dataType: 'script',
    cache: true,
    url: url + '?' + buildNumber,
  });
  return jQuery.ajax(options);
};

$.loadStylesheet = (src) => {
  if (typeof document.createStyleSheet === 'undefined') {
    $('<link>').appendTo('head').attr({
      type: 'text/css',
      rel: 'stylesheet',
      href: src,
    });
  } else {
    // fallback for IE
    document.createStyleSheet(src);
  }
};

/**
 * Basic documentation
 */
/** @global {bool}*/
const _debug = _DEBUG;

/**
 * copy the footnotes 4/5 to add2cart Reco (This text contains an _js_link, so it must be copied before _js_link is initialysed)
 */
basket();

// Init Offcanvas Menu
$('.drilldown', '#main-navigation-off-canvas-wrapper').zeynep();

filterSort();
contactForm();
leaflet();
initWishlist();
headerNav();

amountInput();
tierPriceUpdater();
searchFlyoutState();
photoswipe();
jssinglesubmit();
loadingScreen();

$(document).ready(($) => {
  /**
   * Setzt im Kundenbereich den evtl. vorhandenen Button zum Rgdownload auf show()
   */
  const $invoiceDownloadButton = $('._btn-invoice_download');
  if ($invoiceDownloadButton.length) {
    $invoiceDownloadButton.each(function () {
      const invoiceId = $(this).data('value');
      showInvoiceButton(invoiceId);
    });
  }

  if (
    getCookie('sid') != session &&
    (dataLayer[0].pageType == 'basket' || dataLayer[0].pageType == 'customerarea_login')
  ) {
    $.getJSON('/rpc.php?action=teaser&id=264', function (data) {
      $('#notification-lines').append(data['value']);
    });
  }

  $(function () {
    const delay = 1000 + Math.floor(Math.random() * 1001);
    $('#_contactform_hp_terms_div').addClass('hidden');

    setTimeout(() => {
      $('#terms').prop('disabled', true).removeAttr('required');
    }, delay);
  });

  getTeaserDyn();
});

function getTeaserDyn() {
  console.log('::::: Starte dynteaserFunction for:' + dataLayer[0].pageType);

  $.ajax({
    type: 'GET',
    url: '/rpc.php/?action=dynamicteaser',
    data: {
      dl_pagetype: dataLayer[0].pageType,
    },
    success: function (result) {
      console.log(result);
      //result.forEach (renderTeaserDyn);
      for (let i in result) {
        console.log(i);
        //console.log(result[i]);
        renderTeaserDyn(result[i]);
      }
    },
    error: function () {
      console.log('::::: ERROR');
    },
  });
}
function renderTeaserDyn(teaser_item) {
  console.log(':::::  Start rendering teaser: ' + teaser_item['tsr_name']);
  console.log(teaser_item);
  console.log(teaser_item['tsr_name']);
  // tsr_load_dynamic_method:
  // before append after replaceWith
  switch (teaser_item['tsr_load_dynamic_method']) {
    case 'before':
      $(teaser_item['tsr_load_value']).before(teaser_item['tsr_value_wrapped']);
      break;
    case 'append':
      $(teaser_item['tsr_load_value']).append(teaser_item['tsr_value_wrapped']);
      break;
    case 'after':
      $(teaser_item['tsr_load_value']).after(teaser_item['tsr_value_wrapped']);
      break;
    case 'replaceWith':
      $(teaser_item['tsr_load_value']).replaceWith(teaser_item['tsr_value_wrapped']);
      break;
    default:
      break;
  }
}

// add missing function for customer area
function showInvoiceButton(id) {
  $.ajax({
    type: 'GET',
    // url: '/kundenbereich/hasinvoice/'+id
    url: '/kundenbereich/hasinvoice/' + id,
  })
    .fail(function () {
      console.log(id + 'error');
    })
    .done(function (result) {
      if (result == '1') {
        $('#_btn-invoice_download_' + id).show(700);
        $('#_btn-invoice_nodownload_' + id).hide();
      }
    });
}

productlist();

const addMeToLC = () => {
  $.get('/rpc.php', { action: 'addMeToLC' })
    .always(() => {
      $('a#addMeToLC').text('Danke');
      $('.login-mtext').parents('.row.apn-message-orange:first').delay(1200).hide(600);
    })
    .done((data) => {
      if (_DEBUG) {
        console.log('Data Loaded: ' + data);
      }
    });
};

// SEO Text Collapse
$('.apn-seo-collapse')
  .after()
  .on('click touch', (event) => {
    $(event.currentTarget).collapse('toggle');
  });

$('._cmpscreencustomopen').on('click touch', (event) => {
  __cmp('showScreenAdvanced');
  event.preventDefault();
});

/** collapse seo text */
$('.apn-text-collapse').on('click', (event) => {
  $(event.target).toggleClass('closed');
});

// Anchor on Product Detail Page opens dropdown target (only mobile)
$('.apn-product-detail-information-more').on('click', function () {
  $('#dropdown-product-info-1').collapse('show');
});

// Exorbyte replaces search input in DOM, we have to initalize again
const clearInputNode = $('#apn-header-search .apn-clear-input').get(0);
if (clearInputNode) {
  const searchInputObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        aponeo.clearInput();
      }
    });
  });
  searchInputObserver.observe(clearInputNode, { childList: true });
}

(function openCollapseFromAnchorLink(hash) {
  try {
    if (hash && $(hash).length) {
      var collapseId = $(hash).first().data('collapseOpen');
      var $collapse = collapseId ? $('#' + collapseId) : null;
      if ($collapse && $collapse.length && $collapse.collapse) {
        $collapse.collapse('show');
      }
    }
  } catch (ex) {
    //ignore invalid anchors
  }
})(window.location.hash);

// Set Device Classes
if (aponeo.isMobile()) {
  $('body').addClass('isMobile');
}
if (aponeo.isTablet()) {
  $('body').addClass('isTablet');
}

// Load Stylesheets for search
// 5382_sparmed_dev (dev/test/staging project)
$(document).ready(($) => {
  $.loadStylesheet('https://d25a50wq0hgskv.cloudfront.net/5382_sparmed_dev/lib/ecsSuggest.css.gz');
  $.loadStylesheet('https://d25a50wq0hgskv.cloudfront.net/5382_sparmed_dev/sncustom/sntemplate.css.gz');
});

headroom();

password();

packstation();

header();

announcementBar();

checkout();

megamenu();

productdetail();
stickyCartFlyout();

interactionCheck();

productTeaser();

freeShippingProgress();

const $apnHelp = $('.js-apn-help');
if ($apnHelp.length) {
  import('../../shared/js/modules/faq').then(({ default: faq }) => faq($apnHelp));
}

// ### Guarantee Label Opener ###
$(document).on('click', '._guarantee-label-opener', function () {
  $('#modal-eu-guarantee-basic').modal();
});

customer_area();

initiateSliders();

selectBox();

radioToggle();

backToTopFixed();
pdpSkyWrapper();

formValidation();

coupons();
